import React, { useEffect, useState } from "react";
import { getSliders } from "../Service/Api";
const BASE_URL =
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

const HomeSlider = () => {
  const [sliderData, setSliderData] = useState([]);

  useEffect(() => {
    async function loadSliders() {
      try {
        const data = await getSliders();

        const visibleSliders = Array.isArray(data)
          ? data
            .filter((item) => item.visibility === false)
            .sort((a, b) => a.position - b.position)
          : [];

        setSliderData(visibleSliders);
      } catch (error) {
        console.error(error);
      }
    }

    loadSliders();
  }, []);

  const dummyData = [
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/sld0.jpg",
  ];

  const slides =
    sliderData.length > 0
      ? sliderData.map((item) => `${BASE_URL}${item.attachment}`)
      : dummyData;

  return (
    <div className="slider-sec">
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {slides.map((img, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              data-bs-interval="3000"
            >
              <img
                src={img}
                className="d-block w-100"
                alt={`slide-${index}`}
              />
            </div>
          ))}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
      <div className="overBox">
        <h2>Will Durant</h2>
        <p>
          Knowledge is the eye of desire and can became the polot of the soul
        </p>
        <a href="About">
          <button className="button">
            EXPLORE <i class="bi bi-chevron-double-right"></i>
          </button>
        </a>

      </div>
    </div>
  );
};

export default HomeSlider;